import { render, staticRenderFns } from "./QuestionExport.vue?vue&type=template&id=0235b934&scoped=true&"
import script from "./QuestionExport.vue?vue&type=script&lang=js&"
export * from "./QuestionExport.vue?vue&type=script&lang=js&"
import style0 from "./QuestionExport.vue?vue&type=style&index=0&id=0235b934&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235b934",
  null
  
)

export default component.exports